import {ICell, ICellMetricAggregator} from "./PA.HyperRectangle.IF";
import * as _ from 'lodash'

export class WAvgMetricAggr
    implements ICellMetricAggregator
{
    private _metricId: string
    private _metricIdWght: string
    private _WAvgNum: number
    private _WAvgDen: number
    private _sum: number
    private _count: number
    private bWAvg: boolean
    private _dfltValue: number

    constructor(metricId: string, wAvgMetricId?: string, defaultValue?: number) {
        this._metricId = metricId
        this._metricIdWght = wAvgMetricId
        this._sum = 0
        this._count = 0
        this._WAvgDen = 0
        this._WAvgNum = 0
        this.bWAvg = !_.isEmpty(wAvgMetricId)
        this._dfltValue = defaultValue || 0
    }

    add(cell: ICell): void {
        let incrValue = _.toNumber(cell.getCellMetricValue(this._metricId))
        let weight = 0
        if(this.bWAvg)
            weight = _.toNumber(cell.getCellMetricValue(this._metricIdWght))

        this._sum += _.toNumber(incrValue)
        this._count += 1
        this._WAvgNum += (incrValue * weight)
        this._WAvgDen += weight
    }

    getResults(): string | number {
        if(this._WAvgDen != 0)
            return this._WAvgNum / this._WAvgDen
        else if (this._count > 0)
            return this._sum / this._count
        else
            return this._dfltValue
    }

}